// extracted by mini-css-extract-plugin
export var mutuallink = "mutuallink-module--mutuallink--b4834";
export var mutuallink_contents = "mutuallink-module--mutuallink_contents--a2399";
export var mutuallink_site = "mutuallink-module--mutuallink_site--af9b7";